export default {
  teamEvents: {
    header: {
      title: 'Find your perfect team event',
      description:
        'More than {eventCount} classes and workshops. Request your team event today.',
      buttonLabel: 'Send your request',
    },

    button: {
      label: 'Request an event',
      boxLabel: 'Request this kit',
    },
  },
}
